var React = require('react');

function Propeller (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(0 62)"},[React.createElement("path",{"fill":"#65A0CA","d":"M2.56728559,0.625021053 C-1.90686413,0.625021053 2.58397796,15.8576175 2.58397796,15.8576175 C2.58397796,15.8576175 7.04143532,0.625021053 2.56728559,0.625021053","key":0}),React.createElement("path",{"fill":"#598BAB","d":"M2.56728559,30.9808175 C7.04143532,30.9820105 2.58397796,15.7500105 2.58397796,15.7500105 C2.58397796,15.7500105 -1.9086526,30.9808175 2.56728559,30.9808175","key":1})]));
}

Propeller.defaultProps = {"width":"5","height":"156","viewBox":"0 0 5 156"};

module.exports = Propeller;

Propeller.default = Propeller;
